/**
 * A/V feature flags.
 *
 * Flip USE_JOIN_SHEET to `true` to restore the legacy two-step flow
 * where the user first picks a join mode (video / audio / off) before
 * entering the call. When `false`, the channel is auto-joined in
 * receive-only mode and the AV button opens the toggles sheet directly.
 */
export const AV_CONFIG = {
  USE_JOIN_SHEET: false,
} as const
